import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { usePoll } from 'shared/hooks/usePoll'
import { wagerExternalGamesSubDirectory } from 'shared/constants/slots'

import { getWagerSlots } from 'features/slots/actions'

const WagerSlotsPolling: React.FC = () => {
  const dispatch = useDispatch()

  const handleGetWagerSlots = useCallback(async () => {
    dispatch(getWagerSlots(wagerExternalGamesSubDirectory))
  }, [dispatch])

  usePoll(handleGetWagerSlots, { delay: 3 * 60 })

  return null
}

export default WagerSlotsPolling
